import { COMPONENTS } from '../../../components/components.registry';
import { RecommendationsConfig } from '../../../models';

export const DEFAULT_RECOMMENDATIONS_CONFIG: RecommendationsConfig = {
  components: {
    panel: COMPONENTS.PURE.DefaultRecommendations,
    grid: COMPONENTS.PURE.DefaultGrid,
    result: COMPONENTS.SMART.ConfigurableResult
  },
  infiniteScrollDefaultEnabled: true,
  gridColumns: 6,
  pageSize: 12
};
